<template>
  <span class="exportBtn">
    <lk-button :type="type"  :icon="icon" @click.stop.prevent="handleClick">
        <span>{{text}}</span>
    </lk-button>
  </span>
</template>

<script>
export default {
  name: 'downloadButton',
  props: {
    text: {
      type: String,
      default: '导出Excel',
    },
    type: {
      type: String,
      default: 'primary',
    },
    icon: {
      type: String,
      default: 'md-download',
    },
    id: {
      type: String,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    handleClick(e) {
      const target = e.target;
      const downloadCart = this.$root.$children[0].$children[0].$refs.downloadCart; // 导出购物车的位置
      // this.$root.$children[0].downloadingCount = downloadCart.$props.count + 1; // 导出数量+1
      // this.$root.$children[0].getDownloadingFile(); // 触发轮询接口
      downloadCart.drop(target);
      this.$emit('on-click', target);
    },
  },
  created() {
  },
};
</script>
<style lang="less" scoped>
.exportBtn{
  display: inline-block;
}
</style>
